<template>
  <div class="bg_mask mask_black">
    <vue-loading id="vue-loading" class="load" type="spin" color="#009FA9" :size="{ width: '120px', height: '120px' }"></vue-loading>
    <div v-if="title || message" class="loading_message">
      <p v-if="title" class="loading_message_title">{{ title }}</p>
      <p v-if="message" class="loading_message_text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'
export default {
  name: 'loading',
  // components: {
  //   VueLoading,
  // },
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  mounted() {
    let svg = document.getElementById('vue-loading');
    let animateTransform = svg.getElementsByTagName('animateTransform')[0];
    animateTransform.setAttribute('dur', '1.5s'); // 回転速度を下げる
  }
}
</script>

<style lang="css" scoped>
.bg_mask{
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.mask_black {
  background-color: rgba(0, 0, 0, .3);
}

.load.vue-loading {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.loading_message {
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  left: 50%;
  max-width: 380px;
  padding: 20px 16px;
  position: fixed;
  text-align: center;
  top: 60%;
  transform: translateX(-50%);
  width: 90%;
  z-index: 2;
}

.loading_message_title,
.loading_message_text {
  color: #000;
}

.loading_message_title {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4;
  margin: 0 0 8px;
}

.loading_message_text {
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue